import actions from "./actions";
import mutations from "./mutations";

export default {
  namespaced: true,
  state: {
    tableLoading: false,
    trainings: [],
    currentTraining: null,
    total: 0,
    currentPage: 1,
    perPage: 10,
    searchQuery: "",
  },
  actions,
  mutations,
};
